import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { Moment } from "moment";
import { 
  Options,
  ChartData,
  Assessment,
  AlertZone,
  AssessmentTypes
} from "./expanded-dashboard.types";
import { ClientDDL, ClientInfo } from "@/views/base/base.types";
import { PatientSummary } from "@/views/summary/summary.types";


@Component({
  computed: {
    ...mapState("ExpandedDashboard", [
      "phq9ChartOptions",
      "gad7ChartOptions",
      "sowsChartOptions",
      "cravingsChartOptions",
      "labels",
      "phq9ChartData",
      "gad7ChartData",
      "sowsChartData",
      "cravingsChartData",
      "noOfDays",
      "startDate",
      "endDate",
      "assessmentChoices",
      "phq9Assessment",
      "gad7Assessment",
      "sowsAssessment",
      "cravingsAssessment",
      "phq9AlertZones",
      "gad7AlertZones",
      "sowsAlertZones",
      "cravingsAlertZones"
    ]),
    ...mapState("Base", [
      "selectedClientDDL",
      "clientInfo"
    ]),
    ...mapState("Summary", [
      "selectedPatientSummary"
    ])
  }
})
export default class ExpandedDashboardMixin extends Vue {
  clientInfo!: ClientInfo[];
  labels!: string[][];
  phq9AlertZones!: AlertZone[];
  gad7AlertZones!: AlertZone[];
  sowsAlertZones!: AlertZone[];
  cravingsAlertZones!: AlertZone[];
  phq9ChartData!: ChartData;
  gad7ChartData!: ChartData;
  sowsChartData!: ChartData;
  cravingsChartData!: ChartData;
  phq9ChartOptions!: Options;
  gad7ChartOptions!: Options;
  sowsChartOptions!: Options;
  cravingsChartOptions!: Options;
  phq9Assessment!: Assessment;
  gad7Assessment!: Assessment;
  sowsAssessment!: Assessment;
  cravingsAssessment!: Assessment;
  assessmentChoices!: string[];
  selectedClientDDL!: ClientDDL;
  selectedPatientSummary!: PatientSummary;
  noOfDays!: number;
  startDate!: Moment;
  endDate!: Moment;

  get selectedClient() {
    return this.clientInfo.find(
      item => item.clientId === this.selectedClientDDL.value
    ) ?? new ClientInfo;
  }

  getAssessentType(assessmentType: string): number {
    switch (assessmentType) {
      case "PHQ-9":
        return AssessmentTypes.PHQ9;
      case "GAD-7":
        return AssessmentTypes.GAD7;
      case "COWS":
        return AssessmentTypes.SOWS;
      case "Cravings":
        return AssessmentTypes.Cravings;
      default:
        return 0;
    }
  }
}